import { create } from "apisauce";
import { API_TIMEOUT } from "../constants/api";
import configs from "../constants/configs";

const API = create({
  baseURL: configs.endPoint,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
const API_AUTH = create({
  baseURL: configs.endPoint,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
const API_AUTH_FILE = create({
  baseURL: configs.endPoint,
  timeout: API_TIMEOUT,
  headers: {}
});

function setTokenBase(token, link) {
  API_AUTH.setHeader("Authorization", token);
  API_AUTH_FILE.setHeader("Authorization", token);
  API_AUTH_FILE.setBaseURL(link);
  API_AUTH.setBaseURL(link);
}

function setTokenGlobal(token) {
  API_AUTH.setHeader("Authorization", token);
  API_AUTH_FILE.setHeader("Authorization", token);
}
function setBaseURL(link) {
  API_AUTH.setBaseURL(link);
  API_AUTH_FILE.setBaseURL(link);
}
const API_AUTH_CHOTT = create({
  baseURL: configs.apiChoThongTinVay,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json",
    // "Access-Control-Allow-Headers": "*",
    // "Access-Control-Allow-Origin": "*",
    // "Access-Control-Allow-Methods": "*"  
  },
});
const API_AUTH_WebMorman = create({
  baseURL: configs.apiWebMorman,
  timeout: API_TIMEOUT,
  headers: {
    Accept: "application/json",
    "Content-Type": "application/json"
  },
});

export { API, API_AUTH, API_AUTH_FILE, API_AUTH_CHOTT, API_AUTH_WebMorman, setTokenGlobal, setBaseURL, setTokenBase };
